import { useUiStore } from '@app/core/ui/stores/ui.store';
import { useUserSettingsStore } from '@app/core/user-settings/stores/user-settings.store';
import { useFragmentsSettingsStore } from '@app/modules/fragments/stores/fragments-settings.store';
import { useStatusSettingsStore } from '@app/modules/logger/screens/status/stores/status-settings.store';
import { useStreamSettingsStore } from '@app/modules/logger/screens/stream/stores/stream-screen-settings.store';
import { usePostHogSettingsSyncFromStore } from './usePostHogSettingsSyncFromStore';

export function usePostHogSettingsSync() {
  usePostHogSettingsSyncFromStore(useUiStore, 'ui', ['sidenavOpen', 'themeMode']);

  usePostHogSettingsSyncFromStore(useUserSettingsStore, 'user', ['timezone', 'locale']);

  usePostHogSettingsSyncFromStore(useStatusSettingsStore, 'status', ['view']);

  usePostHogSettingsSyncFromStore(useStreamSettingsStore, 'stream', [
    'audit',
    'mode',
    'autoOpenFragmentMode',
    'playOnCursorSet',
    'keepSelectionOnRangeChange',
  ]);

  usePostHogSettingsSyncFromStore(useFragmentsSettingsStore, 'fragments', ['viewMode']);
}
